export default __webpack_public_path__ + "static/media/creator_hero3.2f5030c9.png";